import { LabelCheckBox, LabelHeaderCheckBox } from "@icoach/components";
import { isEqual } from "@util/utils";
import React from "react";
import { BATCH_DEDUCTION } from "@icoach/batchPayment/staticData";

export const getCheckRowsLabel = () => ({
	cellKey: "orderID",
	isIcon: true,
	headerLabel: ({ headerCheckBoxRef, onHeaderChange }) => {
		return <LabelHeaderCheckBox ref={headerCheckBoxRef} onChange={onHeaderChange} />;
	},
	formatCell: (value, rowData = {}, { activeAction, checkBoxsRef, onCheckBoxChange, getCheckedItems, sequence }) => {
		const key = `${value}_${sequence}`;

		let isChecked = false;
		if ((getCheckedItems() || []).includes(key)) isChecked = true;


		return (
			<LabelCheckBox
				ref={(el) => (checkBoxsRef.current[key] = el)}
				onChange={onCheckBoxChange}
				idKey={key}
				defalutCehecked={isChecked}
				sourceData={rowData}
				disabled={isEqual(activeAction, BATCH_DEDUCTION) ? !rowData?.canPayment : false}
			/>
		);
	}
});